import { SimulationResult } from "@/proposal/components/simulation/common/SimulationResultBadge"
import { SimulationStatus } from "@/query/graphql"
import type { SeatbeltCheck } from "@/tallyProposal/hooks/useProposalSimulation"

export const mapCheckStatusToSimulationResult = (
  status: SeatbeltCheck["status"],
): SimulationResult => {
  switch (status) {
    case "passed":
      return SimulationResult.Success
    case "warning":
      return SimulationResult.Warning
    case "error":
      return SimulationResult.Failed
    case "failed":
      return SimulationResult.Failed
    default:
      return SimulationResult.Unknown
  }
}

/**
 * Maps SimulationStatus enum values to SimulationResult enum values.
 * @param status - The simulation status from GraphQL
 */
export const mapSimulationStatusToSimulationResult = (
  status: SimulationStatus,
): SimulationResult => {
  switch (status) {
    case SimulationStatus.Success:
      return SimulationResult.Passed
    case SimulationStatus.Failed:
      return SimulationResult.Failed
    default:
      return SimulationResult.Unknown
  }
}

export const mapStatusToSimulationStatus = (
  status: string,
): SimulationStatus => {
  switch (status) {
    case SimulationStatus.Success:
      return SimulationStatus.Success
    case SimulationStatus.Failed:
      return SimulationStatus.Failed
    default:
      return SimulationStatus.Success
  }
}
